<div class="sync-user-container">

  <div class="form-decorator top-decorator flex w-full align-items-center mb-4">
    <div class="title">Email użytkownika</div>
    <div class="w-full">
      <input 
        id="email-input"
        type="email" 
        pInputText 
        [ngModel]="email()"
        (ngModelChange)="email.set($event)"
        placeholder="np. user@example.com"
        class="default-input w-full"
        [disabled]="loading()"
        (keyup.enter)="startSync()"
      />
    </div>
  </div>

  <div class="result-section" *ngIf="result()">
    <div 
      class="result-message"
      [class.result-message--success]="result()?.success"
      [class.result-message--error]="!result()?.success">
      {{ result()?.message }}
    </div>
  </div>

  <div class="sync-actions flex justify-content-end gap-2 mt-6">
    <p-button 
      label="Anuluj"
      icon="pi pi-times"
      [outlined]="true"
      severity="secondary"
      [disabled]="loading()"
      (onClick)="closeDialog()" data-clarity-unmask="true">
    </p-button>
    
    <p-button 
      *ngIf="result()"
      label="Resetuj"
      icon="pi pi-refresh"
      [outlined]="true"
      [disabled]="loading()"
      (onClick)="reset()" data-clarity-unmask="true">
    </p-button>

    <p-button 
      label="Synchronizuj"
      icon="pi pi-sync"
      [loading]="loading()"
      [disabled]="!email() || loading()"
      (onClick)="startSync()" data-clarity-unmask="true">
    </p-button>
  </div>
</div>
